var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 674,
    viewBox: "0 0 345 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.545 0L279.668 0V624.439C279.668 651.811 257.478 674 230.106 674C202.734 674 180.545 651.811 180.545 624.439V0Z",
    fill: "#E29578"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 562.875,
    y: 241.916,
    width: 124.192,
    height: 562.876,
    rx: 62.096,
    transform: "rotate(90 562.875 241.916)",
    fill: "#005B7F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 667.898,
    y: 200.518,
    width: 82.7946,
    height: 562.876,
    rx: 41.3973,
    transform: "rotate(90 667.898 200.518)",
    fill: "#679ACB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 326.004,
    width: 80.2073,
    height: 564.056,
    rx: 40.1036,
    transform: "rotate(90 721 326.004)",
    fill: "#E8F8FE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFaq);
export default __webpack_public_path__ + "static/media/IllustrationFAQ.dba342b4a0ebdeae8b165c092192eef5.svg";
export { ForwardRef as ReactComponent };